import React from 'react';
import IntensityBadge from '../ui/IntensityBadge';

// Opinionated wrapper around IntensityBadge for training zones —
// picks the right color + Hebrew description per zone. New zones
// should match the TrainingZone Literal in backend/skills/plan_schema.py.
const ZONE_CONFIG = {
  'Zone 1':    { color: 'green',   label: 'Zone 1 · התאוששות' },
  'Zone 2':    { color: 'emerald', label: 'Zone 2 · קל אירובי' },
  'Zone 3':    { color: 'teal',    label: 'Zone 3 · אירובי יציב' },
  'Threshold': { color: 'orange',  label: 'Threshold · סף לקטי' },
  'VO2max':    { color: 'red',     label: 'VO2max · עומס מקסימלי' },
  'Intervals': { color: 'rose',    label: 'Intervals · אינטרוולים' },
  'Race Pace': { color: 'purple',  label: 'Race Pace · קצב מרוץ' },
  'Hills':     { color: 'amber',   label: 'Hills · עליות / כוח' },
  'Recovery':  { color: 'slate',   label: 'Recovery · שחרור' },
};

export default function ZoneBadge({ zone, size = 'lg' }) {
  if (!zone) return null;
  const config = ZONE_CONFIG[zone] || { color: 'blue', label: zone };
  return (
    <IntensityBadge
      label={config.label}
      color={config.color}
      size={size}
      title={zone}
    />
  );
}
